module.exports = __webpack_public_path__ + "static/media/branch.8d05b208.svg";